import { configureStore } from "@reduxjs/toolkit";
import astroReducer from './astroSlice'
import myProfileReducer from "./myProfileSlice"
export const store=configureStore({
    reducer:{
        astro:astroReducer,
        myProfile:myProfileReducer
    }
})